import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_DASHBOARD,
} from "./actionTypes"

import {
  getDashboardSuccess,
  getDashboardFail,
} from "./actions"

import { getDashboard } from "../../helpers/backend_helper"

function* fetchDashboard({ payload: { options, history } }) {
  try {
    const response = yield call(getDashboard, options)
    yield put(getDashboardSuccess(response))
  } catch (error) {
    yield put(getDashboardFail(error))
  }
}

function* dashboardSaga() {
  yield takeEvery(GET_DASHBOARD, fetchDashboard)
}

export default dashboardSaga
